<div class="alerte-container" [ngClass]="{ 'alerte-card': isCard,'success': niveau == niveauAlerteEnum.NO_CONTROL,'error': niveau == niveauAlerteEnum.ERROR,'warning': niveau == niveauAlerteEnum.WARNING,
    'rgpd': niveau == niveauAlerteEnum.RGPD,'profil-user': niveau == niveauAlerteEnum.PROFIL_USER }">
    <div *ngFor="let alerte of listeAlertes">
        <ng-template [ngTemplateOutlet]="alerte.template"></ng-template>
    </div>
</div>
